// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
import admission from './admission'
import checkEmail from './check-email'
import permissions from './permissions'
import branches from './branches'
import branchProperties from './branches/branch-properties'
import roles from './roles'
import rolePermissions from './rolePermissions'
import rootReducerUsers from './users'
import listDepartmentReducer from './departments'
import locations from './locations'
import clients from './clients'
import partners from './partners'
import conditionalHours from './branches/condtional-hours'
import holidays from './branches/holidays'
import healthcareSupports from './healthcareSupports'
import regions from './regions'
import regionals from './regionals'
import branchTypes from './branch-types'
import specialists from './specialists'
import serviceCategories from './service-categories'
import labTestMethods from './lab-test-methods'
import normalDescriptions from './normal-descriptions'
import examinations from './examinations'
import abnormalDescriptions from './abnormal-descriptions'
import abnormalRiskLevels from './abnormal-risk-level'
import serviceDomains from './service-domains'
import serviceGroups from './service-groups'
import titles from './titles'
import services from './services'
import serviceItems from './service-items'
import examinationItems from './examination-items'
import dataAnalysisProperties from './medical-record/analysis/data-analysis/data-analysis-properties'
import serviceClassifications from './service-classifications'
import professions from './professions'
import summaryRecommendations from './summary-recommendations'
import summaryGenerator from './summary-generator'
import summaryGeneratorConditions from './summary-generator/summary-generator-conditions'
import jobTitles from './job-titles'
import resultCategories from './result-categories'
import mappingData from './mapping-data'
import summaryGeneratorLibrary from './summary-generator-library'
import summaryGeneratorLibraryConditions from './summary-generator-library/summary-generator-conditions'
import bmiCriteries from './bmi-criteries'
import identityTypes from './identity-types'
import responsibleDoctors from './responsible-doctors'
import mcuProjects from './mcu-projects'
import mcuProjectPackage from './mcu-project-package'
import mcuProjectPackageServices from './package-services'
import generalProjectSummary from './mcu-project-summary'
import mcuProjectCrs from './mcu-project-crs'
import mcuProjectPeriod from './mcu-project-period'
import mcuProjectPeriodCutOff from './mcu-project-period-cut-off'
import mcuProjectPatientBatch from './mcu-project-patient-batch'
import mcuProjectPatient from './mcu-project-patient'
import mcuProjectAdditionalServices from './additional-services'
import mcuProjectPatientImport from './patient-import'
import mcuProjectSupportingDocs from './mcu-project-supporting-docs'
import mcuProjectConfigurationBMICriteries from './mcu-project-configuration-bmi-criteria'
import mcuProjectSlaConfiguration from './mcu-project-sla-configuration'
import patient from './patient'
import profileConfiguration from './profile-configuration'
import profileconfig from './profileconfig'
import userProfileSetup from './user-profile-setup'
import patientsManagementTypes from './patient-management'
import autoCompleteTexts from './autocomplete-texts'
import packageAdditionalInfo from './package-additional-info'
import servicePrices from './service-prices'
import branchTeams from './branch-teams'
import others from './others'
import cashiers from './cashiers'
import examinationResults from './examination-results'
import headers from './headers'
import resultRecaps from './result-recaps'
import bulkProcess from './bulk-process'
import medicalDocuments from './medical-documents'
import itemClassifications from './item-classifications'
import industries from './industries'
import resultConclusionLibraries from './result-conclusion-libraries'
import examinationResultsLaboratory from './laboratory'
import listTextTemplateReducer from './text-template'
import listBranchConfigurationReducer from './branch-configuration'
import listIntegrationApiReducer from './settings/integration-api'
import lisMappingItems from './lis-mapping-items'
import transactionData from './synchronize-data/transaction-data'
import branchPriceCategory from './branch-price-category'
import masterData from './synchronize-data/master-data'
import serviceTypes from './service-type'
import listPriceCategoryReducer from './price-category'
import listExportBillingReducer from './exports/export-billing'
import listExportTransactionReducer from './exports/export-transaction'
import listExportDataReducer from './exports/export-data'
import analysis from './analysis'
import slaResult from './sla-result'
import resendOrderLis from './resend-order-lis'
import configuration from './configuration'
import listGeneralConfiguration from './general-configuration'
import dataAnalysisReducer from './medical-record/analysis/data-analysis'
import dataCriticalCasePropertiesReducer from './medical-record/critical-case'
import packagePriceCategoryReducer from './branch-package-category'
import holidaysReducer from './holidays'
import servicePriceCategoryReducer from './branch-service-category'
import packages from './packages'
import sampleStationPlatformOperationSection from './sample-station-section'
import stations from './stations'
import zebraPrintReducer from './zebra-print'
import importExaminationResults from './import-examination-results'
import crud from './master-crud'
import projectPartnerReducer from './project-partner'
import summaries from './summaries'
import masterDetailProcess from './master-detail-process'
import tools from './tools'
import promo from './promo'
import promoGroups from './promo-groups'
import bulkprocessRefect from './refect-bulk'
import mcuProjectNoteReducer from './mcu-project-note'
import mcuProjectServicePrice from './mcu-project-service-price'
import partnerPackageServiceData from './partner-admission'
import insuranceReducer from './insurance'
import dashboardReducer from './dashboard'
import queueReducer from './queue'
import patientCenterReducer from './patient-center'
import listBranchPractitionerReducer from './branch-practitioner'
import shifts from './shift'
import workFitnesses from './work-fitness'
import generalPriceSetups from './general-price-setup'
import pharmacyPrices from './branch-pharmacy-price'
import odontogram from './odontogram'
import emrMedicalDocuments from './emr-medical-documents'
import { createImportReducer } from '../reducers/reusable-import'
import { createImportActions } from '../actions/reusable-import'
import documentClassifications from './document-classifications'
import projectInvoiceDoc from './project-invoice-doc'
import billingInvoices from './billing-invoices'
import contentManagement from './content-management'
import manageCreditLimit from './manage-credit-limit'

const importExtendActions = createImportActions('IMPORT_EXTEND_SLA', {})
const importExtendSlaResults = createImportReducer(importExtendActions.types)

const importInvoiceSettlementActions = createImportActions('IMPORT_INVOICE_SETTLEMENT', {})
const importInvoiceSettlement = createImportReducer(importInvoiceSettlementActions.types)

const rootReducer = combineReducers({
  dataAnalysisReducer,
  auth,
  users: rootReducerUsers,
  listPriceCategoryReducer,
  listExportBillingReducer,
  listExportTransactionReducer,
  listExportDataReducer,
  listBranchConfigurationReducer,
  listTextTemplateReducer,
  navbar,
  checkEmail,
  layout,
  permissions,
  branches,
  branchProperties,
  roles,
  rolePermissions,
  departments: listDepartmentReducer,
  locations,
  clients,
  partners,
  conditionalHours,
  admission,
  holidays,
  healthcareSupports,
  regions,
  regionals,
  branchTypes,
  specialists,
  serviceCategories,
  labTestMethods,
  normalDescriptions,
  examinations,
  abnormalDescriptions,
  abnormalRiskLevels,
  serviceDomains,
  serviceGroups,
  titles,
  services,
  serviceItems,
  examinationItems,
  serviceClassifications,
  professions,
  dataAnalysisProperties,
  summaryRecommendations,
  summaryGenerator,
  summaryGeneratorConditions,
  jobTitles,
  resultCategories,
  summaryGeneratorLibrary,
  summaryGeneratorLibraryConditions,
  bmiCriteries,
  identityTypes,
  responsibleDoctors,
  mcuProjects,
  mcuProjectPackage,
  mcuProjectPackageServices,
  generalProjectSummary,
  mcuProjectCrs,
  mcuProjectPeriod,
  mcuProjectPeriodCutOff,
  mcuProjectPatientBatch,
  mappingData,
  mcuProjectPatient,
  mcuProjectAdditionalServices,
  mcuProjectPatientImport,
  mcuProjectConfigurationBMICriteries,
  mcuProjectSlaConfiguration,
  mcuProjectSupportingDocs,
  patient,
  profileConfiguration,
  profileconfig,
  userProfileSetup,
  patientsManagementTypes,
  autoCompleteTexts,
  packageAdditionalInfo,
  servicePrices,
  branchTeams,
  others,
  cashiers,
  examinationResults,
  headers,
  resultRecaps,
  bulkProcess,
  medicalDocuments,
  itemClassifications,
  industries,
  resultConclusionLibraries,
  examinationResultsLaboratory,
  listIntegrationApiReducer,
  lisMappingItems,
  transactionData,
  branchPriceCategory,
  masterData,
  serviceTypes,
  analysis,
  slaResult,
  configuration,
  listGeneralConfiguration,
  resendOrderLis,
  packagePriceCategoryReducer,
  servicePriceCategoryReducer,
  holidaysReducer,
  packages,
  sampleStationPlatformOperationSection,
  stations,
  zebraPrintReducer,
  importExaminationResults,
  crud,
  projectPartnerReducer,
  summaries,
  masterDetailProcess,
  tools,
  promo,
  promoGroups,
  bulkprocessRefect,
  mcuProjectServicePrice,
  mcuProjectNoteReducer,
  partnerPackageServiceData,
  insuranceReducer,
  dashboardReducer,
  queueReducer,
  patientCenterReducer,
  dataCriticalCasePropertiesReducer,
  listBranchPractitionerReducer,
  shifts,
  generalPriceSetups,
  pharmacyPrices,
  workFitnesses,
  odontogram,
  emrMedicalDocuments,
  importExtendSlaResults,
  importInvoiceSettlement,
  documentClassifications,
  projectInvoiceDoc,
  billingInvoices,
  contentManagement,
  manageCreditLimit
})

export default rootReducer
